import { render, staticRenderFns } from "./StepInformation.vue?vue&type=template&id=2c7112bf&"
import script from "./StepInformation.vue?vue&type=script&lang=js&"
export * from "./StepInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c7112bf')) {
      api.createRecord('2c7112bf', component.options)
    } else {
      api.reload('2c7112bf', component.options)
    }
    module.hot.accept("./StepInformation.vue?vue&type=template&id=2c7112bf&", function () {
      api.rerender('2c7112bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/external/StepInformation.vue"
export default component.exports